import React from 'react';
import { IconProps } from './types';

const ErrorIcon: React.FC<IconProps> = props => {
  const { height = '16', width = '16', fillColor = '#C76B00' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99992 4.66658C8.36659 4.66658 8.66659 4.96658 8.66659 5.33325V7.99992C8.66659 8.36659 8.36659 8.66659 7.99992 8.66659C7.63325 8.66659 7.33325 8.36659 7.33325 7.99992V5.33325C7.33325 4.96658 7.63325 4.66658 7.99992 4.66658ZM7.99325 1.33325C4.31325 1.33325 1.33325 4.31992 1.33325 7.99992C1.33325 11.6799 4.31325 14.6666 7.99325 14.6666C11.6799 14.6666 14.6666 11.6799 14.6666 7.99992C14.6666 4.31992 11.6799 1.33325 7.99325 1.33325ZM7.99992 13.3333C5.05325 13.3333 2.66659 10.9466 2.66659 7.99992C2.66659 5.05325 5.05325 2.66659 7.99992 2.66659C10.9466 2.66659 13.3333 5.05325 13.3333 7.99992C13.3333 10.9466 10.9466 13.3333 7.99992 13.3333ZM8.66659 11.3333H7.33325V9.99992H8.66659V11.3333Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default ErrorIcon;
